import { FC, ReactNode } from 'react';
import { IconButton, Stack, StackProps, Typography } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Searchbox } from '@components/common';
import { ISearchboxProps } from '@components/common/Searchbox';

interface IPortalPageTitleProps extends Omit<StackProps, 'title'> {
	title: ReactNode;
	subtitle?: ReactNode;
	paddingX?: number | string;
	onBackButtonClick?: () => void;
	displaySearchbox?: boolean;
	searchboxProps?: ISearchboxProps;
}

export const PortalPageTitle: FC<IPortalPageTitleProps> = ({
	title,
	subtitle,
	paddingX,
	onBackButtonClick,
	displaySearchbox,
	searchboxProps,
	sx,
	children,
	...props
}) => {
	return (
		<Stack direction="row" justifyContent="space-between" sx={{ paddingX, ...sx }} {...props}>
			<Stack direction="column" spacing={1}>
				<Stack direction="row" alignItems="center" spacing={1}>
					{onBackButtonClick ? (
						<IconButton onClick={onBackButtonClick} size="small" color="inherit">
							<KeyboardBackspaceIcon />
						</IconButton>
					) : null}
					<Typography variant="h3" fontWeight={800}>
						{title}
					</Typography>
				</Stack>
				{subtitle ? <Typography sx={{ paddingLeft: onBackButtonClick ? 6 : 0 }}>{subtitle}</Typography> : null}
			</Stack>
			{children}
			{displaySearchbox ? <Searchbox {...searchboxProps} /> : null}
		</Stack>
	);
};
